import { render } from "./configSar.vue?vue&type=template&id=cb84455e&scoped=true"
import script from "./configSar.vue?vue&type=script&lang=js"
export * from "./configSar.vue?vue&type=script&lang=js"

import "./configSar.vue?vue&type=style&index=0&id=cb84455e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb84455e"]])

export default __exports__